/** Must stay in sync with VoucherImportModal row shape / POST /api/vouchers/import. */
export const VOUCHER_IMPORT_COLUMN_COUNT = 9;

export const VOUCHER_IMPORT_HEADERS = [
  'child_name',
  'case_number',
  'agreement_number',
  'eligibility_type',
  'aa',
  'sda',
  'ada',
  'cda',
  'total'
];
